import {Component} from '@angular/core';

import { Question, QuestionKind, Rule } from '../../../common/models/flow.dto';
import { StateBuilderService, ConfigurationType } from '../../services/state-builder.service';
import { SidePanelBase } from "../../../common/components/side-panel-base.class";

@Component({
    selector: 'state-builder-data',
    templateUrl: './state-builder-data.component.html',
    styleUrls: ['./state-builder-data.component.scss'],
    standalone: false
})

export class StateBuilderDataComponent extends SidePanelBase {
    static componentName = 'StateBuilderDataComponent';


    get currentQuestion() {
      if (this.componentData.currentQuestion === null || this.componentData.currentQuestion === undefined) {
        return {
          key: "",
          label: "",
          helpText: "",
          config: [],
          type: QuestionKind.Checkbox,
          contextTarget: "",
          initialDataContextTarget: "",
          enabledRule: null,
          validationRules: [],
          visibleRule: null,
          changeRules: [],
          flexGrow: -1,
          //files: [],
          notes: [],
          defaultValue: undefined
        } as Question;
      } else {
        return this.componentData.currentQuestion;
      }
    }

    get selectedState() {
      return this.componentData.selectedState;
    }

    get currentTemplate() {
      return this.componentData.currentTemplate;
    }

    constructor(public _stateBuilderService: StateBuilderService) {
        super();
    }

    ngOnInit() {
        if (this.currentQuestion.initialDataContextTarget && !this.currentQuestion.initialDataContextTargetRule) {
            this.currentQuestion.initialDataContextTargetRule = {
                name: "Initial Data Context Target",
                expression: this.currentQuestion.initialDataContextTarget,
                ruleId: ""
            } as Rule;
        }
    }

    getConfigurationType(type: string): string {
        return this._stateBuilderService.getConfigurationType(type as QuestionKind).data;
    }

    getConfiguration(type: string): ConfigurationType {
        return this._stateBuilderService.getConfigurationType(type as QuestionKind);
    }

    hasData(): boolean {
      return this._stateBuilderService.hasData(this.currentQuestion);
    }

    initialTargetUpdated(rule: Rule): void {
        if (rule) {
            this.currentQuestion.initialDataContextTarget = rule.expression;
            this.currentQuestion.initialDataContextTargetRule = rule;
        }
    }
}